import { BEN_HILL_GRIFFIN_DATA } from "@/data/benHillGriffinData";
import { ExternalLink } from "lucide-react";

export const StadiumMapLegend = () => {
  const featureTypes = [
    { icon: "🤫", label: "Sensory Room / Quiet Space", color: "#34D399" },
    { icon: "♿", label: "Wheelchair Accessible", color: "#FBBF24" },
    { icon: "🎧", label: "Sensory-Friendly Seating", color: "#86EFAC" },
    { icon: "🏥", label: "Medical / First Aid", color: "#F87171" },
    { icon: "ℹ️", label: "Guest Services", color: "#60A5FA" },
    { icon: "🚪", label: "Emergency Exit / Gate", color: "#22C55E" },
    { icon: "🚻", label: "Accessible Restroom", color: "#A78BFA" },
  ];

  const energyLevels = [
    { color: "#34D399", label: "Low Energy (Quiet)" },
    { color: "#FBBF24", label: "Medium Energy" },
    { color: "#F87171", label: "High Energy (LOUD)" },
  ];

  const unseenDisabilities = BEN_HILL_GRIFFIN_DATA.unseenDisabilitiesSupport;

  return (
    <div className="space-y-4">
      {/* Feature Types */}
      <div
        className="info-card"
        role="region"
        aria-label="Stadium map legend"
        data-testid="stadium-map-legend"
      >
        <h3
          className="text-sm font-semibold mb-3"
          style={{ fontFamily: "Lexend, sans-serif" }}
        >
          Accessibility Features
        </h3>
        <div className="grid grid-cols-2 gap-2">
          {featureTypes.map((item) => (
            <div key={item.label} className="flex items-center gap-2 text-xs">
              <span className="text-base">{item.icon}</span>
              <span className="text-muted-foreground">{item.label}</span>
            </div>
          ))}
        </div>

        {/* Energy Levels */}
        <h3
          className="text-sm font-semibold mb-2 mt-4 pt-3 border-t"
          style={{ fontFamily: "Lexend, sans-serif" }}
        >
          Sensory Levels
        </h3>
        <div className="flex flex-wrap gap-3">
          {energyLevels.map((item) => (
            <div key={item.label} className="flex items-center gap-2 text-xs">
              <span
                className="w-3 h-3 rounded-full border border-white shadow-sm"
                style={{ backgroundColor: item.color }}
              />
              <span className="text-muted-foreground">{item.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Unseen Disabilities Support */}
      <div className="info-card">
        <h3
          className="text-sm font-semibold mb-3"
          style={{ fontFamily: "Lexend, sans-serif" }}
        >
          Unseen Disabilities Support
        </h3>
        <div className="grid grid-cols-2 gap-2">
          {unseenDisabilities.map((item) => (
            <div
              key={item.label}
              className="flex items-center gap-2 p-2 bg-secondary rounded-lg"
            >
              <span className="text-lg">{item.icon}</span>
              <span className="text-xs font-medium">{item.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Communication Support */}
      <div className="info-card">
        <h3
          className="text-sm font-semibold mb-3"
          style={{ fontFamily: "Lexend, sans-serif" }}
        >
          Communication Support
        </h3>
        <div className="space-y-2">
          {BEN_HILL_GRIFFIN_DATA.communicationSupport.map((item) => (
            <div key={item.name} className="text-xs">
              <span className="font-medium">{item.name}</span>
              {item.contact && (
                <span className="text-muted-foreground block">
                  Contact: {item.contact}
                </span>
              )}
              {item.locations && (
                <span className="text-muted-foreground block">
                  Available at: {item.locations}
                </span>
              )}
              {item.description && (
                <span className="text-muted-foreground block text-xs italic">
                  {item.description}
                </span>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Website Link */}
      <a
        href="https://www.inclusivegameday.com"
        target="_blank"
        rel="noopener noreferrer"
        className="info-card flex items-center gap-3 bg-gradient-to-r from-[#0021A5] to-[#FA4616] text-white hover:opacity-90 transition-opacity"
        data-testid="inclusivegameday-link"
      >
        <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
          <ExternalLink size={20} />
        </div>
        <div>
          <p className="font-semibold text-sm">More Resources</p>
          <p className="text-xs text-white/80">www.inclusivegameday.com</p>
        </div>
      </a>
    </div>
  );
};
